import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { flowRight as compose } from 'lodash';
// Style
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';

// Components
import Payout from './Payout';
import Refund from './Refund';
import CurrencyConverter from '../../CurrencyConverter';
import ModalForm from './ModalForm';
import CustomPagination from '../../CustomPagination';
import CommonTable from '../../CommonTable/CommonTable';
import TableAction from '../../CommonTable/TableAction';
import Loader from '../../Loader/Loader';
import ReservationActionsMenu from './ReservationActionsMenu';
import InspectionStatusBadge from '../../Inspection/InspectionStatusBadge/InspectionStatusBadge';
import ins from '../../Inspection/Inspection.css';
import adm from '../InspectionAdmin/InspectionAdmin.css';

//Helper
import formatReservationState from '../../../helpers/formatReservationState';
import { getDynamicTitle } from '../../../helpers/GetDynamicItemName/getDynamicName';
import {
  ADMIN_TABS, countAdminTabs, matchesAdminTab, matchesPeriod, formatInspectionStatus, globalStatusKey, globalStatusTone
} from '../../../helpers/inspectionPresentation';

import cs from '../../../components/commonStyle.css';
import s from './ReservationManagement.css';
import messages from '../../../locale/jsonMessages';

class ReservationManagement extends React.Component {

  static propTypes = {
    title: PropTypes.string.isRequired,
    data: PropTypes.shape({
      loading: PropTypes.bool.isRequired,
      refetch: PropTypes.any.isRequired,
      getTransactionHistory: PropTypes.shape({
        count: PropTypes.number.isRequired,
        reservationData: PropTypes.arrayOf(PropTypes.shape({
          id: PropTypes.number.isRequired,
          listId: PropTypes.number.isRequired,
          hostId: PropTypes.string.isRequired,
          guestId: PropTypes.string.isRequired,
          checkIn: PropTypes.string.isRequired,
          checkOut: PropTypes.string.isRequired,
          guestServiceFee: PropTypes.number.isRequired,
          hostServiceFee: PropTypes.number.isRequired,
          total: PropTypes.number.isRequired,
          currency: PropTypes.string.isRequired,
          reservationState: PropTypes.string.isRequired,
          listData: PropTypes.shape({
            title: PropTypes.string.isRequired
          }),
          hostData: PropTypes.shape({
            profileId: PropTypes.number.isRequired,
            firstName: PropTypes.string.isRequired
          }),
          hostPayout: PropTypes.shape({
            id: PropTypes.number.isRequired,
            payEmail: PropTypes.string.isRequired,
            methodId: PropTypes.number.isRequired,
            currency: PropTypes.string.isRequired,
            last4Digits: PropTypes.number
          }),
          hostTransaction: PropTypes.shape({
            id: PropTypes.number.isRequired,
          }),
          guestData: PropTypes.shape({
            profileId: PropTypes.number.isRequired,
            firstName: PropTypes.string.isRequired
          }),
          transaction: PropTypes.shape({
            payerEmail: PropTypes.string.isRequired,
            paymentType: PropTypes.string.isRequired,
            total: PropTypes.number.isRequired,
            currency: PropTypes.string.isRequired,
            paymentMethodId: PropTypes.number
          }),
          refundStatus: PropTypes.shape({
            id: PropTypes.number.isRequired,
            receiverEmail: PropTypes.string.isRequired,
            total: PropTypes.number.isRequired,
            currency: PropTypes.string.isRequired
          }),
          cancellationDetails: PropTypes.shape({
            refundToGuest: PropTypes.number.isRequired,
            payoutToHost: PropTypes.number.isRequired,
            total: PropTypes.number.isRequired,
            currency: PropTypes.string.isRequired,
            guestServiceFee: PropTypes.number.isRequired,
            hostServiceFee: PropTypes.number.isRequired,
          }),
        })),
      }),
    }).isRequired,
    viewReceiptAdmin: PropTypes.any.isRequired,
  };

  static defaultProps = {
    data: {
      loading: true,
      getAllReservationAdmin: {
        count: null,
        reservationData: []
      }
    }
  };

  constructor(props) {
    super(props);
    this.state = {
      currentPage: 1,
      searchList: '',
      typing: false,
      typingTimeout: 0,
      selectedRefund: [],
      successRefund: [],
      selectedPayout: [],
      successPayout: [],
      tab: 'all',
      periodFrom: '',
      periodTo: '',
    };
    this.paginationData = this.paginationData.bind(this);
    this.changeState = this.changeState.bind(this);
    this.handleSearchChange = this.handleSearchChange.bind(this);
    this.handleClick = this.handleClick.bind(this);
  }

  changeState(type, value) {
    const { selectedRefund, successRefund, selectedPayout, successPayout } = this.state;
    const { searchList, currentPage, getAllReservationAdmin: { refetch }, reservationState } = this.props;
    let variables = {};

    if (type === 'addRefund') {
      variables = { selectedRefund: [...selectedRefund, value] };
    }
    if (type === 'removeRefund') {
      let index = selectedRefund.findIndex(i => i === value);
      if (index === -1) return '';
      let data = [...selectedRefund];
      data.splice(index, 1)
      variables = { selectedRefund: data };
    }
    if (type === 'successRefund') {
      variables = { successRefund: [...successRefund, value] };
    }

    if (type === 'addPayout') {
      variables = { selectedPayout: [...selectedPayout, value] };
    }
    if (type === 'removePayout') {
      let index = selectedPayout.findIndex(i => i === value);
      if (index === -1) return '';
      let data = [...selectedPayout];
      data.splice(index, 1)
      variables = { selectedPayout: data };
    }
    if (type === 'successPayout') {
      variables = { successPayout: [...successPayout, value] };
      refetch({ currentPage, searchList, reservationState });
    }
    this.setState(variables)
  }

  paginationData(currentPage) {
    const { getAllReservationAdmin: { refetch }, changeStateValues, searchList, reservationState } = this.props;
    let variables = { currentPage, searchList, reservationState };
    changeStateValues(variables);
    refetch(variables);
  }

  handleClick(searchList) {
    const { getAllReservationAdmin: { refetch }, changeStateValues, reservationState } = this.props;
    let variables = {
      currentPage: 1,
      searchList: searchList, reservationState
    };
    changeStateValues(variables);
    refetch(variables);
  }

  handleSearchChange = (e) => {
    const self = this;
    if (self.state.typingTimeout) {
      clearTimeout(self.state.typingTimeout);
    }
    self.setState({
      searchList: e.target.value,
      typing: false,
      typingTimeout: setTimeout(function () {
        self.handleClick(self.state.searchList);
      }, 450)
    });
  };

  tableStatusFilter = () => {
    const { formatMessage } = this.props.intl;
    return [
      { value: "", label: formatMessage(messages.all) },
      { value: "pending", label: formatMessage(messages.messageStatus5) },
      { value: "approved", label: formatMessage(messages.messageStatus4) },
      { value: "cancelled", label: formatMessage(messages.messageStatus11) },
      { value: "completed", label: formatMessage(messages.completedLabel) }
    ]
  }

  handleDropDown = (e) => {
    const { searchList, changeStateValues, getAllReservationAdmin: { refetch } } = this.props
    const variables = { currentPage: 1, searchList, reservationState: e.target.value };
    changeStateValues(variables);
    refetch(variables);
  };

  thead = () => {
    const { formatMessage } = this.props.intl;
    return [
      { data: formatMessage(messages.reservationId) },
      { data: formatMessage(messages.codeLabel) },
      { data: formatMessage(messages.status) },
      { data: formatMessage(messages.carNameLabel) },
      { data: formatMessage(messages.refundToRenter) },
      { data: formatMessage(messages.subTotalLabel) },
      { data: formatMessage(messages.payoutLabelAdmin) },
      { data: formatMessage(messages.inspCheckinTitle) },
      { data: formatMessage(messages.inspCheckoutTitle) },
      { data: formatMessage(messages.inspAdmColDamages) },
      { data: formatMessage(messages.inspAdmColDeposit) },
      { data: formatMessage(messages.inspAdmColGlobalStatus) },
      { data: formatMessage(messages.inspAdmColActions) },
    ]
  };

  // Tabs and period act on the reservations of the displayed page (the list is paginated by the server).
  visibleRows = () => {
    const { getAllReservationAdmin: { getAllReservationAdmin } } = this.props;
    const { tab, periodFrom, periodTo } = this.state;
    return (getAllReservationAdmin?.reservationData || []).filter((value) => matchesAdminTab(value, tab) && matchesPeriod(value, periodFrom, periodTo));
  };

  damageCell = (value) => {
    const { formatMessage } = this.props.intl;
    if (value.hasDamage === true) return <InspectionStatusBadge entry={{ labelKey: 'inspAdmDamageYes', tone: 'danger', icon: 'alert' }} />;
    if (value.hasDamage === false) return <span>{formatMessage(messages.inspAdmDamageNone)}</span>;
    return <span>-</span>;
  };

  tbody = (props) => {
    const { locale, dynamicTitle } = props;
    const { formatMessage } = this.props.intl;
    const { selectedRefund, successRefund, selectedPayout, successPayout } = this.state;

    return this.visibleRows().map(value => {
      let dynamicTitleContent, dynamicTitle;
      if (value?.dynamicListTitle) {
        dynamicTitleContent = JSON.parse(value?.dynamicListTitle)
        dynamicTitle = getDynamicTitle({ data: dynamicTitleContent, locale, id: value?.listId });
      }
      return {
        id: value?.id,
        data: [
          { data: value.id },
          {
            data: <div className={cx(cs.displayFlex, cs.alignCenter, cs.spaceBetween)}>
              {value?.confirmationCode}
              <TableAction
                showView={true}
                link={`/siteadmin/viewreservation/${value.id}/reservation`}
              />
            </div>
          },
          { data: <span>{formatReservationState(value.reservationState, { formatMessage })}</span> },
          {
            data: (value.listTitle || value.listData) ? <div><a href={"/cars/" + value.listId} target='_blank'>
              {dynamicTitle || (value.listTitle ? value.listTitle : value.listData.title)}
            </a></div> : <>{formatMessage(messages.carNameIsMissing)}</>

          },
          {
            data: <Refund
              id={value.id}
              reservationState={value.reservationState}
              transactionData={value.transaction}
              refundData={value.refundStatus}
              cancelData={value.cancellationDetails}
              selectedRefund={selectedRefund}
              changeState={this.changeState}
              successRefund={successRefund}
            />
          },
          {
            data: <CurrencyConverter
              amount={value.total + value.guestServiceFee}
              from={value.currency}
            />
          },
          {
            data: <Payout
              hostId={value.hostId}
              checkIn={value.checkIn}
              id={value.id}
              hostPayout={value.hostPayout}
              amount={value.total}
              currency={value.currency}
              hostTransaction={value.hostTransaction}
              reservationState={value.reservationState}
              cancelData={value.cancellationDetails}
              hostData={value.hostData}
              hostServiceFee={value.hostServiceFee}
              promoDiscount={value?.promoDiscount}
              promoCodeType={value?.promoCodeType}
              selectedPayout={selectedPayout}
              successPayout={successPayout}
              changeState={this.changeState}
            />
          },
          { data: <InspectionStatusBadge entry={formatInspectionStatus(value.checkinStatus)} /> },
          { data: <InspectionStatusBadge entry={formatInspectionStatus(value.checkoutStatus)} /> },
          { data: this.damageCell(value) },
          {
            data: value.securityDeposit > 0
              ? <CurrencyConverter amount={value.securityDeposit} from={value.currency} />
              : <span>{formatMessage(messages.inspAdmDepositNone)}</span>
          },
          {
            data: value.globalStatus
              ? <InspectionStatusBadge entry={{ labelKey: globalStatusKey(value.globalStatus), tone: globalStatusTone(value.globalStatus), icon: globalStatusTone(value.globalStatus) === 'danger' ? 'alert' : globalStatusTone(value.globalStatus) === 'success' ? 'ok' : 'clock' }} />
              : <span>-</span>
          },
          { data: <ReservationActionsMenu reservation={value} /> },
        ]
      }
    })
  }

  tabsBar = () => {
    const { getAllReservationAdmin: { getAllReservationAdmin } } = this.props;
    const { formatMessage } = this.props.intl;
    const { tab, periodFrom, periodTo } = this.state;
    const counts = countAdminTabs(getAllReservationAdmin?.reservationData);
    const labels = {
      all: messages.inspAdmTabAll, in_progress: messages.inspAdmTabInProgress, upcoming: messages.inspAdmTabUpcoming,
      completed: messages.inspAdmTabCompleted, dispute: messages.inspAdmTabDispute, damage: messages.inspAdmTabDamage
    };
    return (
      <div>
        <ul className={adm.tabs} role="tablist" aria-label={formatMessage(messages.inspAdmTabsLabel)}>
          {ADMIN_TABS.map((key) => (
            <li key={key} role="presentation">
              <button
                type="button"
                role="tab"
                aria-selected={tab === key}
                className={cx(adm.tab, tab === key && adm.tabActive)}
                onClick={() => this.setState({ tab: key })}
              >
                <span>{formatMessage(labels[key])}</span>
                <span className={cx(adm.tabCount, key === 'dispute' && counts[key] > 0 && adm.tabCountAlert, key === 'damage' && counts[key] > 0 && adm.tabCountWarn)}>{counts[key]}</span>
              </button>
            </li>
          ))}
        </ul>
        <div className={adm.filters}>
          <div className={adm.filterField}>
            <label className={adm.filterLabel} htmlFor="reservation-period-from">{formatMessage(messages.inspAdmPeriodFrom)}</label>
            <input id="reservation-period-from" type="date" className={adm.dateInput} value={periodFrom} onChange={(event) => this.setState({ periodFrom: event.target.value })} />
          </div>
          <div className={adm.filterField}>
            <label className={adm.filterLabel} htmlFor="reservation-period-to">{formatMessage(messages.inspAdmPeriodTo)}</label>
            <input id="reservation-period-to" type="date" className={adm.dateInput} value={periodTo} onChange={(event) => this.setState({ periodTo: event.target.value })} />
          </div>
          <button type="button" className={cx(ins.button, ins.buttonSecondary)} onClick={() => this.setState({ tab: 'all', periodFrom: '', periodTo: '' })}>{formatMessage(messages.inspAdmReset)}</button>
        </div>
        <p className={adm.scopeNote}>{formatMessage(messages.inspAdmPageScopeNote)}</p>
      </div>
    );
  };

  render() {
    const { getAllReservationAdmin: { loading, getAllReservationAdmin }, currentPage, searchList, reservationState } = this.props;
    const { formatMessage } = this.props.intl;

    if (loading) {
      return <Loader type={"text"} />
    }
    return (
      <div>
        <ModalForm />
        {this.tabsBar()}
        <CommonTable
          thead={this.thead}
          tbody={() => this.tbody(this.props)}
          title={formatMessage(messages.manageReservations)}
          isExport
          exportLink={`/export-admin-data?type=reservations&search=${searchList}&reservationState=${reservationState}`}
          isSearch
          onSearch={this.handleSearchChange}
          filterOption={this.tableStatusFilter()}
          handleFilter={(e) => this.handleDropDown(e)}
          filterValue={reservationState}
        />
        {
          !loading && getAllReservationAdmin?.reservationData?.length > 0
          && <div>
            <CustomPagination
              total={getAllReservationAdmin.count}
              currentPage={currentPage}
              defaultCurrent={1}
              defaultPageSize={10}
              change={this.paginationData}
              paginationLabel={formatMessage(messages.panelReservation)}
            />
          </div>
        }
      </div>
    );
  }

}

const mapState = (state) => ({
  completed: state.reservation.completed,
  loading: state.reservation.loading,
  locale: state?.intl?.locale,
  dynamicTitle: state?.dynamicListTitles?.data?.dynamicListTitle
});

const mapDispatch = {};

export default compose(injectIntl,
  withStyles(cs, s, ins, adm),
  connect(mapState, mapDispatch)
)(ReservationManagement);